import { Box, Stack, Typography, Chip, Paper } from "@mui/material";
import { Layers } from "lucide-react";
import {
  PIPELINE_STAGE_CATALOG,
  getPipelineStage,
} from "../../../config/pipeline.config";

export default function PipelineMultiSelector({
  title,
  icon: Icon = Layers,
  selected,
  setSelected,
  editing,
  filterStatuses = null, // Optional filter to show only specific statuses
}) {
  const toggle = (key) => {
    setSelected((p) =>
      p.includes(key) ? p.filter((k) => k !== key) : [...p, key]
    );
  };

  // Filter stages if filterStatuses is provided
  const displayStages = filterStatuses
    ? PIPELINE_STAGE_CATALOG.filter((stage) => filterStatuses.includes(stage.key))
    : PIPELINE_STAGE_CATALOG;

  return (
    <Paper elevation={0}>
      <Stack direction="row" spacing={1.4} alignItems="center" mb={4}>
        <Icon size={22} color="#4F46E5" />
        <Typography sx={{ fontWeight: 900, fontSize: 19 }}>{title}</Typography>
      </Stack>

      <Stack direction="row" flexWrap="wrap" gap={2}>
        {displayStages.map((stage) => {
          const active = selected.includes(stage.key);

          return (
            <Chip
              key={stage.key}
              icon={
                <Box
                  sx={{
                    width: 26,
                    height: 26,
                    borderRadius: "50%",
                    bgcolor: `${stage.color}22`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {stage.icon}
                </Box>
              }
              label={stage.label}
              clickable={editing}
              onClick={() => editing && toggle(stage.key)}
              sx={{
                px: 3,
                py: 2.5,
                fontSize: 14,
                fontWeight: 700,
                borderRadius: 4,

                bgcolor: active ? stage.color : "#F1F5F9",
                border: active
                  ? `1px solid ${stage.color}55`
                  : "1px solid #E2E8F0",

                boxShadow: active ? `0 6px 16px ${stage.color}55` : "none",

                color: active ? "white" : "#64748B",

                "& .MuiChip-label": {
                  color: active ? "white" : "#64748B",
                },

                "& .MuiChip-icon": {
                  color: active ? "white" : stage.color,
                  opacity: active ? 1 : 0.55,
                },

                transition: "all .18s ease",

                "&:hover": editing
                  ? {
                      bgcolor: active ? stage.color : "#E2E8F0",
                      transform: "translateY(-1px)",
                    }
                  : {},
              }}
            />
          );
        })}
      </Stack>
    </Paper>
  );
}
